import Card from "../../../Common/CommonComponents/Card/card";
import classes from "./programDetails.scss";
import CustomAnchorTag from "../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag";
import Toggle from "../Common/Toggle";
import IneligiblePopup from "../Common/ineligiblePopup";
import ReactHtmlParser from 'react-html-parser';

const ProgramDetails = (props) => {
    const manageLink = () =>{
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:true, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Bank payment method'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|billing_payment|none|bank_payment_method|page|Manage_Payment_Method`) : null;
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().BILLING.MANAGE_PAYMENT);
    };
    const getErrorMsgRgx = (error) => {
        let errorMsgRgx = new RegExp(`<p id="${error}">(.*?)</p>`, 'g');
        let defaulterrorMsgRgx = new RegExp(`<p id="comm-err">(.*?)</p>`, 'g');
        let errorMsgContent ="";
        let defaulterrorMsgContent ="";
        errorMsgContent = !_.isEmpty(props.ineligibleMessage) ? props.ineligibleMessage.body.match(errorMsgRgx) : "";
        defaulterrorMsgContent = !_.isEmpty(props.ineligibleMessage) ? props.ineligibleMessage.body.match(defaulterrorMsgRgx) : "";
        return errorMsgContent ? ReactHtmlParser(errorMsgContent) : ReactHtmlParser(defaulterrorMsgContent);

    };
    const getEligibilityData = (eligibilityData, productCode) => {
        return _.filter(eligibilityData, function (item) {
          return item.programDescription === productCode;
        })[0];};


    const getIneligibiltyReason = (program) =>{
       let autoPayData = getEligibilityData(props.eligibilityData, program === 'settingDp'? app.appUtil.getAppConstants().AUTOPAY_CODE : app.appUtil.getAppConstants().PAPERLESS_CODE);
       let errorCode = program === 'settingDp'? '_DP' : '_OB';
       let errorMsgContent = getErrorMsgRgx(autoPayData.ineligibilityReason + errorCode);
       return errorMsgContent ;
    };
    let content = getIneligibiltyReason(props.id);
    let contentHeading = props.id === 'settingDp'? "Account Ineligible for Autopay" : "Account Ineligible for Paperless billing";
    let enrolledDetails = props.enrolledDetails ? <div><span className={classes.sceProgramDetailsLinkSec}>{props.enrolledDetails} - </span><CustomAnchorTag linkName={'Manage'} onClick={()=>props.handleToggleChange(true,'manageLink')} isBold /></div> : null;
    let manageOrEnrolled = props.isManage ? <CustomAnchorTag linkName={'Manage Payment Method'} onClick={manageLink} isBold /> : enrolledDetails;
    let toggle = props.isIneligible ? <IneligiblePopup isUnderline heading={contentHeading} content={content} linkName={"Ineligible"} /> : <Toggle id={props.id} isToggleOn={props.enrolledDetails} handleChange={props.handleToggleChange} />;
    let showToggle = !props.isManage ? toggle : null;

    return (
        <Card>
            <div className={classes.sceProgramDetailsSec}>
                <div>
                    <div className={classes.sceProgramDetailsHeader}>{props.progHeader}</div>
                    <div className={classes.sceProgramDetailsContent}>{props.progSubHeader}</div>   
                    {manageOrEnrolled}
                </div>
                {showToggle}
            </div>
        </Card>
    );
};

export default ProgramDetails;